/**
 * Bandeaux du parrainage (lien invalide, campagne hors fenêtre), connecté ou non : textes de la v1
 * (screens/Account/index.tsx), habillage v2 (`.notice`). Logique : lib/referral.ts.
 */
import type { ReferralContextValue } from 'hooks/useReferralContext';
import { Notice } from './components/Ui';
import { campaignStatusNotice, linkErrorNotice } from './lib/referral';

/** `context` : celui de l'écran (useReferralContext() une seule fois par écran, comme la v1). */
export function ReferralNotices({ context: referralContext }: { context: ReferralContextValue }) {
  const notices = [linkErrorNotice(referralContext), campaignStatusNotice(referralContext)].filter(
    (n): n is NonNullable<typeof n> => n !== null,
  );
  if (!notices.length) return null;
  return (
    <div className="mmv2-acct-notices">
      {notices.map((n) => (
        <Notice key={n.title} tone={n.tone === 'error' ? 'error' : 'warm'} role="alert">
          <b>{n.title}</b> {n.body}
        </Notice>
      ))}
    </div>
  );
}
